module.exports = __webpack_public_path__ + "img/HOUIT-logo.cd3d22e6.png";